// Helpers for firing and capturing test events.

import { UtilityText } from 'component/text';
import { useEffect, useState } from 'react';
import { View } from 'react-native';

const global_testEventReceiver = {} as Record<string, ((event: string) => void) | null>;

export function TestEventReceiver({ sinkKey = 'test-event-receiver' }) {
    const [events, setEvents] = useState<string[]>([]);

    function addEvent(event: string) {
        setEvents((oldEvents) => [...oldEvents, event]);
    }

    useEffect(() => {
        global_testEventReceiver[sinkKey] = addEvent;
        return () => {
            global_testEventReceiver[sinkKey] = null;
        };
    }, []);

    return (
        <View>
            {events.map((event, index) => (
                <UtilityText key={index} text={event} />
            ))}
        </View>
    );
}

export function sendTestEvent(sinkKey: string, event: string) {
    if (global_testEventReceiver[sinkKey]) {
        global_testEventReceiver[sinkKey]!(event);
    }
}
